export interface Translations {
  // Common
  'app.title': string;
  'nav.home': string;
  'nav.about': string;
  'nav.login': string;
  'nav.register': string;
  'nav.logout': string;
  'common.loading': string;
  'common.error': string;
  'common.success': string;
  'common.submit': string;
  'common.cancel': string;
  'common.save': string;
  'common.delete': string;
  'common.edit': string;
  'common.view': string;
  'common.download': string;
  'common.share': string;
  'common.copy': string;
  'common.search': string;
  'common.filter': string;
  'common.sort': string;
  'common.back': string;
  'common.next': string;
  'common.previous': string;
  'common.close': string;
  'common.select': string;
  'common.upload': string;
  'common.generate': string;
  'common.analyze': string;
  'auth.login.fillAllFields': string;
  'auth.login.welcomeBack': string;
  'auth.login.error': string;
  'auth.login.googleComingSoon': string;
  'auth.register.error': string;
  'auth.logout.success': string;
  'language.english': string;
  'language.hindi': string;
  'language.select': string;
  'theme.light': string;
  'theme.dark': string;
  'theme.switchToLight': string;
  'theme.switchToDark': string;

  // Home Page
  'home.hero.title': string;
  'home.hero.subtitle': string;
  'home.hero.description': string;
  'home.hero.getStarted': string;
  'home.hero.learnMore': string;
  'home.features.title': string;
  'home.features.subtitle': string;
  'home.features.aiPowered': string;
  'home.features.aiPoweredDesc': string;
  'home.features.personalized': string;
  'home.features.personalizedDesc': string;
  'home.features.comprehensive': string;
  'home.features.comprehensiveDesc': string;
  'home.features.accessible': string;
  'home.features.accessibleDesc': string;
  'home.cta.title': string;
  'home.cta.description': string;
  'home.cta.startTrial': string;
  'home.cta.signIn': string;

  // About Page
  'about.title': string;
  'about.subtitle': string;
  'about.description': string;
  'about.mission.title': string;
  'about.mission.description': string;
  'about.vision.title': string;
  'about.vision.description': string;
  'about.values.title': string;
  'about.values.innovation': string;
  'about.values.innovationDesc': string;
  'about.values.accessibility': string;
  'about.values.accessibilityDesc': string;
  'about.values.excellence': string;
  'about.values.excellenceDesc': string;

  // Authentication
  'auth.login.title': string;
  'auth.login.subtitle': string;
  'auth.login.email': string;
  'auth.login.password': string;
  'auth.login.rememberMe': string;
  'auth.login.forgotPassword': string;
  'auth.login.noAccount': string;
  'auth.login.createAccount': string;
  'auth.login.signInWith': string;
  'auth.login.google': string;
  'auth.login.asTeacher': string;
  'auth.login.asStudent': string;
  'auth.register.title': string;
  'auth.register.subtitle': string;
  'auth.register.teacher': string;
  'auth.register.student': string;
  'auth.register.fullName': string;
  'auth.register.email': string;
  'auth.register.password': string;
  'auth.register.confirmPassword': string;
  'auth.register.phone': string;
  'auth.register.school': string;
  'auth.register.subject': string;
  'auth.register.experience': string;
  'auth.register.classes': string;
  'auth.register.grade': string;
  'auth.register.parentName': string;
  'auth.register.parentPhone': string;
  'auth.register.parentEmail': string;
  'auth.register.address': string;
  'auth.register.hasAccount': string;
  'auth.register.signIn': string;
  'auth.register.terms': string;
  'auth.register.acceptTerms': string;
  'auth.register.backToHome': string;
  'auth.register.joinSahayak': string;
  'auth.register.createAccountDesc': string;
  'auth.register.chooseAccountType': string;
  'auth.register.creating': string;
  'auth.register.createTeacherAccount': string;
  'auth.register.createStudentAccount': string;
  'auth.register.classInfo': string;
  'auth.register.classInfoPlaceholder': string;
  'auth.register.parentEmailPlaceholder': string;
  'auth.register.parentPhonePlaceholder': string;
  'auth.register.namePlaceholder': string;
  'auth.register.emailPlaceholder': string;
  'auth.register.passwordPlaceholder': string;
  'auth.register.selectGrade': string;
  'auth.register.fillRequiredFields': string;
  'auth.register.provideClassInfo': string;
  'auth.register.fillStudentDetails': string;
  'auth.register.welcomeMessage': string;

  // Teacher Dashboard
  'teacher.dashboard.title': string;
  'teacher.dashboard.welcome': string;
  'teacher.dashboard.overview': string;
  'teacher.sidebar.dashboard': string;
  'teacher.sidebar.profile': string;
  'teacher.sidebar.worksheets': string;
  'teacher.sidebar.contentEnhancer': string;
  'teacher.sidebar.performance': string;
  'teacher.sidebar.doubts': string;
  'teacher.sidebar.schedule': string;
  'teacher.sidebar.testAnalysis': string;
  'teacher.overview.totalStudents': string;
  'teacher.overview.activeClasses': string;
  'teacher.overview.assignmentsGraded': string;
  'teacher.overview.avgPerformance': string;
  'teacher.overview.recentActivities': string;
  'teacher.overview.upcomingSchedule': string;
  'teacher.overview.quickActions': string;
  'teacher.overview.generateWorksheet': string;
  'teacher.overview.enhanceContent': string;
  'teacher.overview.analyzePerformance': string;
  'teacher.overview.solveDoubts': string;

  // Teacher Profile
  'teacher.profile.title': string;
  'teacher.profile.personalInfo': string;
  'teacher.profile.name': string;
  'teacher.profile.email': string;
  'teacher.profile.phone': string;
  'teacher.profile.school': string;
  'teacher.profile.subject': string;
  'teacher.profile.experience': string;
  'teacher.profile.classes': string;
  'teacher.profile.joinedDate': string;
  'teacher.profile.editProfile': string;
  'teacher.profile.changePassword': string;
  'teacher.profile.preferences': string;
  'teacher.profile.notifications': string;
  'teacher.profile.emailNotifications': string;
  'teacher.profile.smsNotifications': string;
  'teacher.profile.pushNotifications': string;

  // Worksheet Generator
  'worksheet.title': string;
  'worksheet.subtitle': string;
  'worksheet.subject': string;
  'worksheet.topic': string;
  'worksheet.difficulty': string;
  'worksheet.questionCount': string;
  'worksheet.questionType': string;
  'worksheet.includeAnswers': string;
  'worksheet.additionalInstructions': string;
  'worksheet.selectSubject': string;
  'worksheet.selectDifficulty': string;
  'worksheet.selectQuestionType': string;
  'worksheet.difficulty.easy': string;
  'worksheet.difficulty.medium': string;
  'worksheet.difficulty.hard': string;
  'worksheet.questionType.mcq': string;
  'worksheet.questionType.shortAnswer': string;
  'worksheet.questionType.longAnswer': string;
  'worksheet.questionType.fillBlanks': string;
  'worksheet.questionType.matching': string;
  'worksheet.questionType.trueFalse': string;
  'worksheet.generating': string;
  'worksheet.generated': string;
  'worksheet.preview': string;
  'worksheet.downloadPdf': string;
  'worksheet.shareWithStudents': string;
  'worksheet.regenerate': string;

  // Content Enhancer
  'content.title': string;
  'content.subtitle': string;
  'content.inputContent': string;
  'content.enhancementType': string;
  'content.targetAudience': string;
  'content.additionalInstructions': string;
  'content.pasteContent': string;
  'content.selectEnhancement': string;
  'content.selectAudience': string;
  'content.enhancement.simplify': string;
  'content.enhancement.elaborate': string;
  'content.enhancement.examples': string;
  'content.enhancement.interactive': string;
  'content.enhancement.visual': string;
  'content.audience.elementary': string;
  'content.audience.middle': string;
  'content.audience.high': string;
  'content.audience.college': string;
  'content.enhancing': string;
  'content.enhanced': string;
  'content.enhancedContent': string;
  'content.copyContent': string;
  'content.downloadContent': string;
  'content.postToStudents': string;
  'content.shareLink': string;
  'content.contentCopied': string;
  'content.contentPosted': string;
  'content.linkShared': string;

  // Performance Tracker
  'performance.title': string;
  'performance.subtitle': string;
  'performance.overallPerformance': string;
  'performance.classAverage': string;
  'performance.topPerformers': string;
  'performance.needsAttention': string;
  'performance.subjects': string;
  'performance.assignments': string;
  'performance.tests': string;
  'performance.attendance': string;
  'performance.selectClass': string;
  'performance.selectSubject': string;
  'performance.selectTimeframe': string;
  'performance.thisWeek': string;
  'performance.thisMonth': string;
  'performance.thisQuarter': string;
  'performance.thisYear': string;
  'performance.generateReport': string;
  'performance.exportData': string;
  'performance.insights': string;
  'performance.recommendations': string;

  // Doubt Solver
  'doubts.title': string;
  'doubts.subtitle': string;
  'doubts.pendingDoubts': string;
  'doubts.resolvedDoubts': string;
  'doubts.aiSuggestions': string;
  'doubts.studentName': string;
  'doubts.subject': string;
  'doubts.question': string;
  'doubts.submittedOn': string;
  'doubts.priority': string;
  'doubts.status': string;
  'doubts.respond': string;
  'doubts.markResolved': string;
  'doubts.getAiHelp': string;
  'doubts.priority.high': string;
  'doubts.priority.medium': string;
  'doubts.priority.low': string;
  'doubts.status.pending': string;
  'doubts.status.inProgress': string;
  'doubts.status.resolved': string;

  // Student Dashboard
  'student.dashboard.title': string;
  'student.dashboard.welcome': string;
  'student.sidebar.dashboard': string;
  'student.sidebar.profile': string;
  'student.sidebar.assignments': string;
  'student.sidebar.progress': string;
  'student.sidebar.doubts': string;
  'student.sidebar.schedule': string;
  'student.overview.pendingAssignments': string;
  'student.overview.completedAssignments': string;
  'student.overview.upcomingTests': string;
  'student.overview.overallGrade': string;
  'student.overview.recentActivities': string;
  'student.overview.quickActions': string;
  'student.overview.viewAssignments': string;
  'student.overview.askDoubt': string;
  'student.overview.checkProgress': string;
  'student.overview.viewSchedule': string;

  // Student Profile
  'student.profile.title': string;
  'student.profile.personalInfo': string;
  'student.profile.name': string;
  'student.profile.email': string;
  'student.profile.grade': string;
  'student.profile.school': string;
  'student.profile.rollNumber': string;
  'student.profile.parentInfo': string;
  'student.profile.parentName': string;
  'student.profile.parentPhone': string;
  'student.profile.parentEmail': string;
  'student.profile.address': string;
  'student.profile.joinedDate': string;
  'student.profile.editProfile': string;
  'student.profile.changePassword': string;

  // Assignments
  'assignments.title': string;
  'assignments.pending': string;
  'assignments.completed': string;
  'assignments.overdue': string;
  'assignments.subject': string;
  'assignments.dueDate': string;
  'assignments.status': string;
  'assignments.marks': string;
  'assignments.submit': string;
  'assignments.view': string;
  'assignments.download': string;
  'assignments.feedback': string;

  // Progress
  'progress.title': string;
  'progress.academic': string;
  'progress.subjects': string;
  'progress.overall': string;
  'progress.monthly': string;
  'progress.weekly': string;
  'progress.attendance': string;
  'progress.grades': string;
  'progress.improvement': string;
  'progress.strengths': string;
  'progress.weaknesses': string;

  // Schedule
  'schedule.title': string;
  'schedule.today': string;
  'schedule.week': string;
  'schedule.month': string;
  'schedule.upcoming': string;
  'schedule.class': string;
  'schedule.time': string;
  'schedule.room': string;
  'schedule.teacher': string;
  'schedule.type': string;
  'schedule.lecture': string;
  'schedule.lab': string;
  'schedule.test': string;
  'schedule.assignment': string;

  // Test Analysis
  'testAnalysis.title': string;
  'testAnalysis.subtitle': string;
  'testAnalysis.uploadTest': string;
  'testAnalysis.analyzing': string;
  'testAnalysis.results': string;
  'testAnalysis.insights': string;
  'testAnalysis.recommendations': string;
  'testAnalysis.questionAnalysis': string;
  'testAnalysis.studentPerformance': string;
  'testAnalysis.difficultyDistribution': string;
  'testAnalysis.topicCoverage': string;
  'testAnalysis.improvementAreas': string;
  'testAnalysis.generateReport': string;
}

export type TranslationKey = keyof Translations;

export const translations: Record<'en' | 'hi', Translations> = {
  en: {
    // Common
    'app.title': 'Sahayak AI',
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.login': 'Login',
    'nav.register': 'Register',
    'nav.logout': 'Logout',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.submit': 'Submit',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.view': 'View',
    'common.download': 'Download',
    'common.share': 'Share',
    'common.copy': 'Copy',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.sort': 'Sort',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.previous': 'Previous',
    'common.close': 'Close',
    'common.select': 'Select',
    'common.upload': 'Upload',
    'common.generate': 'Generate',
    'common.analyze': 'Analyze',
    'auth.login.fillAllFields': 'Please fill in all fields',
'auth.login.welcomeBack': 'Welcome back',
'auth.login.error': 'Login failed. Please try again.',
'auth.login.googleComingSoon': 'Google Sign-In integration coming soon!',
'auth.register.error': 'Registration failed. Please try again.',
    'auth.logout.success': 'Logged out successfully',
    'language.english': 'English',
    'language.hindi': 'हिंदी',
    'language.select': 'Select Language',
    'theme.light': 'Light Mode',
    'theme.dark': 'Dark Mode',
    'theme.switchToLight': 'Switch to Light Mode',
    'theme.switchToDark': 'Switch to Dark Mode',

    // Home Page
    'home.hero.title': 'Sahayak AI Frontend',
    'home.hero.subtitle': 'Empowering Education with AI',
    'home.hero.description': 'A comprehensive educational platform designed to enhance teaching and learning experiences through artificial intelligence.',
    'home.hero.getStarted': 'Get Started',
    'home.hero.learnMore': 'Learn More',
    'home.features.title': 'Our Features',
    'home.features.subtitle': 'Everything you need for modern education',
    'home.features.aiPowered': 'AI-Powered Learning',
    'home.features.aiPoweredDesc': 'Intelligent content generation and personalized learning experiences.',
    'home.features.personalized': 'Personalized Dashboard',
    'home.features.personalizedDesc': 'Customized interfaces for teachers and students with role-specific features.',
    'home.features.comprehensive': 'Comprehensive Tools',
    'home.features.comprehensiveDesc': 'From worksheet generation to performance tracking, all in one place.',
    'home.features.accessible': 'Easy to Use',
    'home.features.accessibleDesc': 'Intuitive design that works seamlessly across all devices.',
    'home.cta.title': '🎯 Ready to Transform Education? 🚀',
    'home.cta.description': 'Join thousands of teachers and students already using Sahayak AI to enhance their learning experience.',
    'home.cta.startTrial': 'Start Free Trial',
    'home.cta.signIn': 'Sign In',

    // About Page
    'about.title': 'About Sahayak AI',
    'about.subtitle': 'Revolutionizing Education Through Technology',
    'about.description': 'Sahayak AI Frontend is dedicated to transforming the educational landscape by providing innovative tools and AI-powered solutions for both teachers and students.',
    'about.mission.title': 'Our Mission',
    'about.mission.description': 'To make quality education accessible to everyone through technology and artificial intelligence.',
    'about.vision.title': 'Our Vision',
    'about.vision.description': 'To become the leading platform that bridges the gap between traditional teaching methods and modern educational needs.',
    'about.values.title': 'Our Values',
    'about.values.innovation': 'Innovation',
    'about.values.innovationDesc': 'Continuously improving and adapting to educational needs.',
    'about.values.accessibility': 'Accessibility',
    'about.values.accessibilityDesc': 'Making education tools available to everyone, everywhere.',
    'about.values.excellence': 'Excellence',
    'about.values.excellenceDesc': 'Maintaining the highest standards in educational technology.',

    // Authentication
    'auth.login.title': 'Welcome Back',
    'auth.login.subtitle': 'Sign in to your account',
    'auth.login.email': 'Email Address',
    'auth.login.password': 'Password',
    'auth.login.rememberMe': 'Remember me',
    'auth.login.forgotPassword': 'Forgot password?',
    'auth.login.noAccount': "Don't have an account?",
    'auth.login.createAccount': 'Create one',
    'auth.login.signInWith': 'Or sign in with',
    'auth.login.google': 'Continue with Google',
    'auth.login.asTeacher': 'as Teacher',
    'auth.login.asStudent': 'as Student',
    'auth.register.title': 'Create Account',
    'auth.register.subtitle': 'Join Sahayak AI today',
    'auth.register.teacher': 'Teacher',
    'auth.register.student': 'Student',
    'auth.register.fullName': 'Full Name',
    'auth.register.email': 'Email Address',
    'auth.register.password': 'Password',
    'auth.register.confirmPassword': 'Confirm Password',
    'auth.register.phone': 'Phone Number',
    'auth.register.school': 'School/Institution',
    'auth.register.subject': 'Subject',
    'auth.register.experience': 'Years of Experience',
    'auth.register.classes': 'Classes Teaching',
    'auth.register.grade': 'Grade/Class',
    'auth.register.parentName': 'Parent/Guardian Name',
    'auth.register.parentPhone': 'Parent Phone Number',
    'auth.register.parentEmail': 'Parent Email Address',
    'auth.register.address': 'Address',
    'auth.register.hasAccount': 'Already have an account?',
    'auth.register.signIn': 'Sign In',
    'auth.register.terms': 'Terms of Service',
    'auth.register.acceptTerms': 'I accept the terms and conditions',
    'auth.register.backToHome': 'Back to Home',
    'auth.register.joinSahayak': 'Join Sahayak AI',
    'auth.register.createAccountDesc': 'Create your account to get started',
    'auth.register.chooseAccountType': 'Choose your account type and fill in your details',
    'auth.register.creating': 'Creating Account...',
    'auth.register.createTeacherAccount': 'Create Teacher Account',
    'auth.register.createStudentAccount': 'Create Student Account',
    'auth.register.classInfo': 'Class Information',
    'auth.register.classInfoPlaceholder': 'e.g., Grade 5 Mathematics',
    'auth.register.parentEmailPlaceholder': 'parent@email.com',
    'auth.register.parentPhonePlaceholder': '+91 9876543210',
    'auth.register.namePlaceholder': 'Enter your full name',
    'auth.register.emailPlaceholder': 'Enter your email address',
    'auth.register.passwordPlaceholder': 'Create a strong password',
    'auth.register.selectGrade': 'Select your grade',
    'auth.register.fillRequiredFields': 'Please fill in all required fields',
    'auth.register.provideClassInfo': 'Please provide class information',
    'auth.register.fillStudentDetails': 'Please fill in all student details',
    'auth.register.welcomeMessage': 'Welcome to Sahayak AI',

    // Teacher Dashboard
    'teacher.dashboard.title': 'Teacher Dashboard',
    'teacher.dashboard.welcome': 'Welcome back',
    'teacher.dashboard.overview': 'Dashboard Overview',
    'teacher.sidebar.dashboard': 'Dashboard',
    'teacher.sidebar.profile': 'Profile',
    'teacher.sidebar.worksheets': 'Worksheet Generator',
    'teacher.sidebar.contentEnhancer': 'Content Enhancer',
    'teacher.sidebar.performance': 'Performance Tracker',
    'teacher.sidebar.doubts': 'Doubt Solver AI',
    'teacher.sidebar.schedule': 'Schedule Delivery System',
    'teacher.sidebar.testAnalysis': 'Test Analysis',
    'teacher.overview.totalStudents': 'Total Students',
    'teacher.overview.activeClasses': 'Active Classes',
    'teacher.overview.assignmentsGraded': 'Assignments Graded',
    'teacher.overview.avgPerformance': 'Avg Performance',
    'teacher.overview.recentActivities': 'Recent Activities',
    'teacher.overview.upcomingSchedule': 'Upcoming Schedule',
    'teacher.overview.quickActions': 'Quick Actions',
    'teacher.overview.generateWorksheet': 'Generate Worksheet',
    'teacher.overview.enhanceContent': 'Enhance Content',
    'teacher.overview.analyzePerformance': 'Analyze Performance',
    'teacher.overview.solveDoubts': 'Solve Doubts',

    // Teacher Profile
    'teacher.profile.title': 'Teacher Profile',
    'teacher.profile.personalInfo': 'Personal Information',
    'teacher.profile.name': 'Name',
    'teacher.profile.email': 'Email',
    'teacher.profile.phone': 'Phone',
    'teacher.profile.school': 'School',
    'teacher.profile.subject': 'Subject',
    'teacher.profile.experience': 'Experience',
    'teacher.profile.classes': 'Classes',
    'teacher.profile.joinedDate': 'Joined Date',
    'teacher.profile.editProfile': 'Edit Profile',
    'teacher.profile.changePassword': 'Change Password',
    'teacher.profile.preferences': 'Preferences',
    'teacher.profile.notifications': 'Notifications',
    'teacher.profile.emailNotifications': 'Email Notifications',
    'teacher.profile.smsNotifications': 'SMS Notifications',
    'teacher.profile.pushNotifications': 'Push Notifications',

    // Worksheet Generator
    'worksheet.title': 'Worksheet Generator',
    'worksheet.subtitle': 'Create customized worksheets for your students',
    'worksheet.subject': 'Subject',
    'worksheet.topic': 'Topic',
    'worksheet.difficulty': 'Difficulty Level',
    'worksheet.questionCount': 'Number of Questions',
    'worksheet.questionType': 'Question Type',
    'worksheet.includeAnswers': 'Include Answer Key',
    'worksheet.additionalInstructions': 'Additional Instructions',
    'worksheet.selectSubject': 'Select Subject',
    'worksheet.selectDifficulty': 'Select Difficulty',
    'worksheet.selectQuestionType': 'Select Question Type',
    'worksheet.difficulty.easy': 'Easy',
    'worksheet.difficulty.medium': 'Medium',
    'worksheet.difficulty.hard': 'Hard',
    'worksheet.questionType.mcq': 'Multiple Choice',
    'worksheet.questionType.shortAnswer': 'Short Answer',
    'worksheet.questionType.longAnswer': 'Long Answer',
    'worksheet.questionType.fillBlanks': 'Fill in the Blanks',
    'worksheet.questionType.matching': 'Matching',
    'worksheet.questionType.trueFalse': 'True/False',
    'worksheet.generating': 'Generating Worksheet...',
    'worksheet.generated': 'Worksheet Generated Successfully!',
    'worksheet.preview': 'Preview Worksheet',
    'worksheet.downloadPdf': 'Download PDF',
    'worksheet.shareWithStudents': 'Share with Students',
    'worksheet.regenerate': 'Regenerate',

    // Content Enhancer
    'content.title': 'Content Enhancer',
    'content.subtitle': 'Enhance your educational content with AI',
    'content.inputContent': 'Input Content',
    'content.enhancementType': 'Enhancement Type',
    'content.targetAudience': 'Target Audience',
    'content.additionalInstructions': 'Additional Instructions',
    'content.pasteContent': 'Paste your content here...',
    'content.selectEnhancement': 'Select Enhancement Type',
    'content.selectAudience': 'Select Target Audience',
    'content.enhancement.simplify': 'Simplify',
    'content.enhancement.elaborate': 'Elaborate',
    'content.enhancement.examples': 'Add Examples',
    'content.enhancement.interactive': 'Make Interactive',
    'content.enhancement.visual': 'Add Visual Elements',
    'content.audience.elementary': 'Elementary (Grades 1-5)',
    'content.audience.middle': 'Middle School (Grades 6-8)',
    'content.audience.high': 'High School (Grades 9-12)',
    'content.audience.college': 'College Level',
    'content.enhancing': 'Enhancing Content...',
    'content.enhanced': 'Content Enhanced Successfully!',
    'content.enhancedContent': 'Enhanced Content',
    'content.copyContent': 'Copy Content',
    'content.downloadContent': 'Download Content',
    'content.postToStudents': 'Post to Students',
    'content.shareLink': 'Share Link',
    'content.contentCopied': 'Content copied to clipboard!',
    'content.contentPosted': 'Content posted to students!',
    'content.linkShared': 'Share link generated!',

    // Performance Tracker
    'performance.title': 'Performance Tracker',
    'performance.subtitle': 'Track and analyze student performance',
    'performance.overallPerformance': 'Overall Performance',
    'performance.classAverage': 'Class Average',
    'performance.topPerformers': 'Top Performers',
    'performance.needsAttention': 'Needs Attention',
    'performance.subjects': 'Subjects',
    'performance.assignments': 'Assignments',
    'performance.tests': 'Tests',
    'performance.attendance': 'Attendance',
    'performance.selectClass': 'Select Class',
    'performance.selectSubject': 'Select Subject',
    'performance.selectTimeframe': 'Select Timeframe',
    'performance.thisWeek': 'This Week',
    'performance.thisMonth': 'This Month',
    'performance.thisQuarter': 'This Quarter',
    'performance.thisYear': 'This Year',
    'performance.generateReport': 'Generate Report',
    'performance.exportData': 'Export Data',
    'performance.insights': 'Insights',
    'performance.recommendations': 'Recommendations',

    // Doubt Solver
    'doubts.title': 'Doubt Solver AI',
    'doubts.subtitle': 'AI-powered doubt resolution system',
    'doubts.pendingDoubts': 'Pending Doubts',
    'doubts.resolvedDoubts': 'Resolved Doubts',
    'doubts.aiSuggestions': 'AI Suggestions',
    'doubts.studentName': 'Student Name',
    'doubts.subject': 'Subject',
    'doubts.question': 'Question',
    'doubts.submittedOn': 'Submitted On',
    'doubts.priority': 'Priority',
    'doubts.status': 'Status',
    'doubts.respond': 'Respond',
    'doubts.markResolved': 'Mark Resolved',
    'doubts.getAiHelp': 'Get AI Help',
    'doubts.priority.high': 'High',
    'doubts.priority.medium': 'Medium',
    'doubts.priority.low': 'Low',
    'doubts.status.pending': 'Pending',
    'doubts.status.inProgress': 'In Progress',
    'doubts.status.resolved': 'Resolved',

    // Student Dashboard
    'student.dashboard.title': 'Student Dashboard',
    'student.dashboard.welcome': 'Welcome back',
    'student.sidebar.dashboard': 'Dashboard',
    'student.sidebar.profile': 'Profile',
    'student.sidebar.assignments': 'Assignments',
    'student.sidebar.progress': 'Progress',
    'student.sidebar.doubts': 'Doubts',
    'student.sidebar.schedule': 'Schedule',
    'student.overview.pendingAssignments': 'Pending Assignments',
    'student.overview.completedAssignments': 'Completed Assignments',
    'student.overview.upcomingTests': 'Upcoming Tests',
    'student.overview.overallGrade': 'Overall Grade',
    'student.overview.recentActivities': 'Recent Activities',
    'student.overview.quickActions': 'Quick Actions',
    'student.overview.viewAssignments': 'View Assignments',
    'student.overview.askDoubt': 'Ask a Doubt',
    'student.overview.checkProgress': 'Check Progress',
    'student.overview.viewSchedule': 'View Schedule',

    // Student Profile
    'student.profile.title': 'Student Profile',
    'student.profile.personalInfo': 'Personal Information',
    'student.profile.name': 'Name',
    'student.profile.email': 'Email',
    'student.profile.grade': 'Grade',
    'student.profile.school': 'School',
    'student.profile.rollNumber': 'Roll Number',
    'student.profile.parentInfo': 'Parent Information',
    'student.profile.parentName': 'Parent Name',
    'student.profile.parentPhone': 'Parent Phone',
    'student.profile.parentEmail': 'Parent Email',
    'student.profile.address': 'Address',
    'student.profile.joinedDate': 'Joined Date',
    'student.profile.editProfile': 'Edit Profile',
    'student.profile.changePassword': 'Change Password',

    // Assignments
    'assignments.title': 'Assignments',
    'assignments.pending': 'Pending',
    'assignments.completed': 'Completed',
    'assignments.overdue': 'Overdue',
    'assignments.subject': 'Subject',
    'assignments.dueDate': 'Due Date',
    'assignments.status': 'Status',
    'assignments.marks': 'Marks',
    'assignments.submit': 'Submit',
    'assignments.view': 'View',
    'assignments.download': 'Download',
    'assignments.feedback': 'Feedback',

    // Progress
    'progress.title': 'Progress Tracking',
    'progress.academic': 'Academic Progress',
    'progress.subjects': 'Subject-wise Progress',
    'progress.overall': 'Overall Performance',
    'progress.monthly': 'Monthly Progress',
    'progress.weekly': 'Weekly Progress',
    'progress.attendance': 'Attendance',
    'progress.grades': 'Grades',
    'progress.improvement': 'Areas of Improvement',
    'progress.strengths': 'Strengths',
    'progress.weaknesses': 'Areas to Work On',

    // Schedule
    'schedule.title': 'Schedule',
    'schedule.today': 'Today',
    'schedule.week': 'This Week',
    'schedule.month': 'This Month',
    'schedule.upcoming': 'Upcoming',
    'schedule.class': 'Class',
    'schedule.time': 'Time',
    'schedule.room': 'Room',
    'schedule.teacher': 'Teacher',
    'schedule.type': 'Type',
    'schedule.lecture': 'Lecture',
    'schedule.lab': 'Lab',
    'schedule.test': 'Test',
    'schedule.assignment': 'Assignment',

    // Test Analysis
    'testAnalysis.title': 'Test Analysis',
    'testAnalysis.subtitle': 'AI-powered test analysis and insights',
    'testAnalysis.uploadTest': 'Upload Test Papers',
    'testAnalysis.analyzing': 'Analyzing test papers...',
    'testAnalysis.results': 'Analysis Results',
    'testAnalysis.insights': 'Key Insights',
    'testAnalysis.recommendations': 'Recommendations',
    'testAnalysis.questionAnalysis': 'Question-wise Analysis',
    'testAnalysis.studentPerformance': 'Student Performance',
    'testAnalysis.difficultyDistribution': 'Difficulty Distribution',
    'testAnalysis.topicCoverage': 'Topic Coverage',
    'testAnalysis.improvementAreas': 'Areas for Improvement',
    'testAnalysis.generateReport': 'Generate Report',
  },
  hi: {
    // Common
    'app.title': 'सहायक एआई',
    'nav.home': 'होम',
    'nav.about': 'हमारे बारे में',
    'nav.login': 'लॉगिन',
    'nav.register': 'रजिस्टर',
    'nav.logout': 'लॉगआउट',
    'common.loading': 'लोड हो रहा है...',
    'common.error': 'त्रुटि',
    'common.success': 'सफलता',
    'common.submit': 'जमा करें',
    'common.cancel': 'रद्द करें',
    'common.save': 'सहेजें',
    'common.delete': 'हटाएं',
    'common.edit': 'संपादित करें',
    'common.view': 'देखें',
    'common.download': 'डाउनलोड',
    'common.share': 'साझा करें',
    'common.copy': 'कॉपी करें',
    'common.search': 'खोजें',
    'common.filter': 'फिल्टर',
    'common.sort': 'क्रमबद्ध करें',
    'common.back': 'वापस',
    'common.next': 'आगे',
    'common.previous': 'पिछला',
    'common.close': 'बंद करें',
    'common.select': 'चुनें',
    'common.upload': 'अपलोड',
    'common.generate': 'जेनरेट करें',
    'common.analyze': 'विश्लेषण करें',
    'auth.login.fillAllFields': 'कृपया सभी फ़ील्ड भरें',
'auth.login.welcomeBack': 'वापसी पर स्वागत है',
'auth.login.error': 'लॉगिन विफल रहा। कृपया पुनः प्रयास करें।',
'auth.login.googleComingSoon': 'Google साइन-इन एकीकरण जल्द आ रहा है!',
'auth.register.error': 'पंजीकरण विफल रहा। कृपया पुनः प्रयास करें।',
    'auth.logout.success': 'सफलतापूर्वक लॉगआउट हो गए',
    'language.english': 'English',
    'language.hindi': 'हिंदी',
    'language.select': 'भाषा चुनें',
    'theme.light': 'लाइट मोड',
    'theme.dark': 'डार्क मोड',
    'theme.switchToLight': 'लाइट मोड पर स्विच करें',
    'theme.switchToDark': 'डार्क मोड पर स्विच करें',

    // Home Page
    'home.hero.title': 'सहायक एआई फ्रंटएंड',
    'home.hero.subtitle': 'एआई के साथ शिक्षा को सशक्त बनाना',
    'home.hero.description': 'एक व्यापक शैक्षणिक प्लेटफॉर्म जो कृत्रिम बुद्धिमत्ता के माध्यम से शिक्षण और सीखने के अनुभव को बेहतर बनाने के लिए डिज़ाइन किया गया है।',
    'home.hero.getStarted': 'शुरू करें',
    'home.hero.learnMore': 'और जानें',
    'home.features.title': 'हमारी विशेषताएं',
    'home.features.subtitle': 'आधुनिक शिक्षा के लिए आपको जो कुछ भी चाहिए',
    'home.features.aiPowered': 'एआई-संचालित सीखना',
    'home.features.aiPoweredDesc': 'बुद्धिमान सामग्री निर्माण और व्यक्तिगत सीखने के अनुभव।',
    'home.features.personalized': 'व्यक्तिगत डैशबोर्ड',
    'home.features.personalizedDesc': 'भूमिका-विशिष्ट सुविधाओं के साथ शिक्षकों और छात्रों के लिए अनुकूलित इंटरफेस।',
    'home.features.comprehensive': 'व्यापक उपकरण',
    'home.features.comprehensiveDesc': 'वर्कशीट जेनरेशन से लेकर प्रदर्शन ट्रैकिंग तक, सब कुछ एक ही स्थान पर।',
    'home.features.accessible': 'उपयोग में आसान',
    'home.features.accessibleDesc': 'सहज डिजाइन जो सभी डिवाइसों पर निर्बाध रूप से काम करता है।',
    'home.cta.title': '🎯 शिक्षा को बदलने के लिए तैयार हैं? 🚀',
    'home.cta.description': 'हजारों शिक्षकों और छात्रों के साथ शामिल हों जो पहले से ही अपने सीखने के अनुभव को बेहतर बनाने के लिए सहायक एआई का उपयोग कर रहे हैं।',
    'home.cta.startTrial': 'मुफ्त ट्रायल शुरू करें',
    'home.cta.signIn': 'साइन इन करें',

    // About Page
    'about.title': 'सहायक एआई के बारे में',
    'about.subtitle': 'प्रौद्योगिकी के माध्यम से शिक्षा में क्रांति',
    'about.description': 'सहायक एआई फ्रंटएंड शिक्षकों और छात्रों दोनों के लिए नवाचार उपकरण और एआई-संचालित समाधान प्रदान करके शैक्षणिक परिदृश्य को बदलने के लिए समर्पित है।',
    'about.mission.title': 'हमारा मिशन',
    'about.mission.description': 'प्रौद्योगिकी और कृत्रिम बुद्धिमत्ता के माध्यम से सभी के लिए गुणवत्तापूर्ण शिक्षा सुलभ बनाना।',
    'about.vision.title': 'हमारी दृष्टि',
    'about.vision.description': 'पारंपरिक शिक्षण विधियों और आधुनिक शैक्षणिक आवश्यकताओं के बीच की खाई को पाटने वाला अग्रणी प्लेटफॉर्म बनना।',
    'about.values.title': 'हमारे मूल्य',
    'about.values.innovation': 'नवाचार',
    'about.values.innovationDesc': 'शैक्षणिक आवश्यकताओं के अनुसार निरंतर सुधार और अनुकूलन।',
    'about.values.accessibility': 'पहुंच',
    'about.values.accessibilityDesc': 'शिक्षा उपकरणों को हर जगह, सभी के लिए उपलब्ध कराना।',
    'about.values.excellence': 'उत्कृष्टता',
    'about.values.excellenceDesc': 'शैक्षणिक प्रौद्योगिकी में उच्चतम मानकों को बनाए रखना।',

    // Authentication
    'auth.login.title': 'वापस स्वागत है',
    'auth.login.subtitle': 'अपने खाते में साइन इन करें',
    'auth.login.email': 'ईमेल पता',
    'auth.login.password': 'पासवर्ड',
    'auth.login.rememberMe': 'मुझे याद रखें',
    'auth.login.forgotPassword': 'पासवर्ड भूल गए?',
    'auth.login.noAccount': 'खाता नहीं है?',
    'auth.login.createAccount': 'एक बनाएं',
    'auth.login.signInWith': 'या साइन इन करें',
    'auth.login.google': 'Google के साथ जारी रखें',
    'auth.login.asTeacher': 'शिक्षक के रूप में',
    'auth.login.asStudent': 'छात्र के रूप में',
    'auth.register.title': 'खाता बनाएं',
    'auth.register.subtitle': 'आज ही सहायक एआई में शामिल हों',
    'auth.register.teacher': 'शिक्षक',
    'auth.register.student': 'छात्र',
    'auth.register.fullName': 'पूरा नाम',
    'auth.register.email': 'ईमेल पता',
    'auth.register.password': 'पासवर्ड',
    'auth.register.confirmPassword': 'पासवर्ड की पुष्टि करें',
    'auth.register.phone': 'फोन नंबर',
    'auth.register.school': 'स्कूल/संस्थान',
    'auth.register.subject': 'विषय',
    'auth.register.experience': 'अनुभव के वर्ष',
    'auth.register.classes': 'पढ़ाई जाने वाली कक्षाएं',
    'auth.register.grade': 'कक्षा/ग्रेड',
    'auth.register.parentName': 'अभिभावक/संरक्षक का नाम',
    'auth.register.parentPhone': 'अभिभावक का फोन नंबर',
    'auth.register.parentEmail': 'अभिभावक का ईमेल पता',
    'auth.register.address': 'पता',
    'auth.register.hasAccount': 'पहले से खाता है?',
    'auth.register.signIn': 'साइन इन करें',
    'auth.register.terms': 'सेवा की शर्तें',
    'auth.register.acceptTerms': 'मैं नियम और शर्तों को स्वीकार करता हूं',
    'auth.register.backToHome': 'होम पर वापस जाएं',
    'auth.register.joinSahayak': 'सहायक एआई में शामिल हों',
    'auth.register.createAccountDesc': 'शुरू करने के लिए अपना खाता बनाएं',
    'auth.register.chooseAccountType': 'अपना खाता प्रकार चुनें और अपनी जानकारी भरें',
    'auth.register.creating': 'खाता बनाया जा रहा है...',
    'auth.register.createTeacherAccount': 'शिक्षक खाता बनाएं',
    'auth.register.createStudentAccount': 'छात्र खाता बनाएं',
    'auth.register.classInfo': 'कक्षा की जानकारी',
    'auth.register.classInfoPlaceholder': 'उदाहरण: कक्षा 5 गणित',
    'auth.register.parentEmailPlaceholder': 'parent@email.com',
    'auth.register.parentPhonePlaceholder': '+91 9876543210',
    'auth.register.namePlaceholder': 'अपना पूरा नाम दर्ज करें',
    'auth.register.emailPlaceholder': 'अपना ईमेल पता दर्ज करें',
    'auth.register.passwordPlaceholder': 'एक मजबूत पासवर्ड बनाएं',
    'auth.register.selectGrade': 'अपनी कक्षा चुनें',
    'auth.register.fillRequiredFields': 'कृपया सभी आवश्यक फ़ील्ड भरें',
    'auth.register.provideClassInfo': 'कृपया कक्षा की जानकारी प्रदान करें',
    'auth.register.fillStudentDetails': 'कृपया सभी छात्र विवरण भरें',
    'auth.register.welcomeMessage': 'सहायक एआई में आपका स्वागत है',

    // Teacher Dashboard
    'teacher.dashboard.title': 'शिक्षक डैशबोर्ड',
    'teacher.dashboard.welcome': 'वापस स्वागत है',
    'teacher.dashboard.overview': 'डैशबोर्ड अवलोकन',
    'teacher.sidebar.dashboard': 'डैशबोर्ड',
    'teacher.sidebar.profile': 'प्रोफाइल',
    'teacher.sidebar.worksheets': 'वर्कशीट जेनरेटर',
    'teacher.sidebar.contentEnhancer': 'सामग्री संवर्धक',
    'teacher.sidebar.performance': 'प्रदर्शन ट्रैकर',
    'teacher.sidebar.doubts': 'संदेह समाधान एआई',
    'teacher.sidebar.schedule': 'शेड्यूल',
    'teacher.sidebar.testAnalysis': 'परीक्षा विश्लेषण',
    'teacher.overview.totalStudents': 'कुल छात्र',
    'teacher.overview.activeClasses': 'सक्रिय कक्षाएं',
    'teacher.overview.assignmentsGraded': 'ग्रेड किए गए असाइनमेंट',
    'teacher.overview.avgPerformance': 'औसत प्रदर्शन',
    'teacher.overview.recentActivities': 'हाल की गतिविधियां',
    'teacher.overview.upcomingSchedule': 'आगामी शेड्यूल',
    'teacher.overview.quickActions': 'त्वरित कार्य',
    'teacher.overview.generateWorksheet': 'वर्कशीट जेनरेट करें',
    'teacher.overview.enhanceContent': 'सामग्री बेहतर बनाएं',
    'teacher.overview.analyzePerformance': 'प्रदर्शन का विश्लेषण करें',
    'teacher.overview.solveDoubts': 'संदेह हल करें',

    // Teacher Profile
    'teacher.profile.title': 'शिक्षक प्रोफाइल',
    'teacher.profile.personalInfo': 'व्यक्तिगत जानकारी',
    'teacher.profile.name': 'नाम',
    'teacher.profile.email': 'ईमेल',
    'teacher.profile.phone': 'फोन',
    'teacher.profile.school': 'स्कूल',
    'teacher.profile.subject': 'विषय',
    'teacher.profile.experience': 'अनुभव',
    'teacher.profile.classes': 'कक्षाएं',
    'teacher.profile.joinedDate': 'शामिल होने की तारीख',
    'teacher.profile.editProfile': 'प्रोफाइल संपादित करें',
    'teacher.profile.changePassword': 'पासवर्ड बदलें',
    'teacher.profile.preferences': 'प्राथमिकताएं',
    'teacher.profile.notifications': 'सूचनाएं',
    'teacher.profile.emailNotifications': 'ईमेल सूचनाएं',
    'teacher.profile.smsNotifications': 'SMS सूचनाएं',
    'teacher.profile.pushNotifications': 'पुश सूचनाएं',

    // Worksheet Generator
    'worksheet.title': 'वर्कशीट जेनरेटर',
    'worksheet.subtitle': 'अपने छात्रों के लिए अनुकूलित वर्कशीट बनाएं',
    'worksheet.subject': 'विषय',
    'worksheet.topic': 'विषय',
    'worksheet.difficulty': 'कठिनाई स्तर',
    'worksheet.questionCount': 'प्रश्नों की संख्या',
    'worksheet.questionType': 'प्रश्न प्रकार',
    'worksheet.includeAnswers': 'उत्तर कुंजी शामिल करें',
    'worksheet.additionalInstructions': 'अतिरिक्त निर्देश',
    'worksheet.selectSubject': 'विषय चुनें',
    'worksheet.selectDifficulty': 'कठिनाई चुनें',
    'worksheet.selectQuestionType': 'प्रश्न प्रकार चुनें',
    'worksheet.difficulty.easy': 'आसान',
    'worksheet.difficulty.medium': 'मध्यम',
    'worksheet.difficulty.hard': 'कठिन',
    'worksheet.questionType.mcq': 'बहुविकल्पीय',
    'worksheet.questionType.shortAnswer': 'लघु उत्तर',
    'worksheet.questionType.longAnswer': 'दीर्घ उत्तर',
    'worksheet.questionType.fillBlanks': 'रिक्त स्थान भरें',
    'worksheet.questionType.matching': 'मिलान',
    'worksheet.questionType.trueFalse': 'सत्य/असत्य',
    'worksheet.generating': 'वर्कशीट जेनरेट हो रही है...',
    'worksheet.generated': 'वर्कशीट सफलतापूर्वक जेनरेट हुई!',
    'worksheet.preview': 'वर्कशीट पूर्वावलोकन',
    'worksheet.downloadPdf': 'PDF डाउनलोड करें',
    'worksheet.shareWithStudents': 'छात्रों के साथ साझा करें',
    'worksheet.regenerate': 'पुनः जेनरेट करें',

    // Content Enhancer
    'content.title': 'सामग्री संवर्धक',
    'content.subtitle': 'एआई के साथ अपनी शैक्षणिक सामग्री को बेहतर बनाएं',
    'content.inputContent': 'इनपुट सामग्री',
    'content.enhancementType': 'संवर्धन प्रकार',
    'content.targetAudience': 'लक्षित दर्शक',
    'content.additionalInstructions': 'अतिरिक्त निर्देश',
    'content.pasteContent': 'अपनी सामग्री यहां पेस्ट करें...',
    'content.selectEnhancement': 'संवर्धन प्रकार चुनें',
    'content.selectAudience': 'लक्षित दर्शक चुनें',
    'content.enhancement.simplify': 'सरल बनाएं',
    'content.enhancement.elaborate': 'विस्तार से बताएं',
    'content.enhancement.examples': 'उदाहरण जोड़ें',
    'content.enhancement.interactive': 'इंटरैक्टिव बनाएं',
    'content.enhancement.visual': 'दृश्य तत्व जोड़ें',
    'content.audience.elementary': 'प्रारंभिक (कक्षा 1-5)',
    'content.audience.middle': 'मध्य विद्यालय (कक्षा 6-8)',
    'content.audience.high': 'हाई स्कूल (कक्षा 9-12)',
    'content.audience.college': 'कॉलेज स्तर',
    'content.enhancing': 'सामग्री बेहतर बनाई जा रही है...',
    'content.enhanced': 'सामग्री सफलतापूर्वक बेहतर बनाई गई!',
    'content.enhancedContent': 'संवर्धित सामग्री',
    'content.copyContent': 'सामग्री कॉपी करें',
    'content.downloadContent': 'सामग्री डाउनलोड करें',
    'content.postToStudents': 'छात्रों को पोस्ट करें',
    'content.shareLink': 'लिंक साझा करें',
    'content.contentCopied': 'सामग्री क्लिपबोर्ड में कॉपी हो गई!',
    'content.contentPosted': 'सामग्री छात्रों को पोस्ट कर दी गई!',
    'content.linkShared': 'साझा लिंक जेनरेट हुआ!',

    // Performance Tracker
    'performance.title': 'प्रदर्शन ट्रैकर',
    'performance.subtitle': 'छात्रों के प्रदर्शन को ट्रैक और विश्लेषित करें',
    'performance.overallPerformance': 'समग्र प्रदर्शन',
    'performance.classAverage': 'कक्षा औसत',
    'performance.topPerformers': 'शीर्ष प्रदर्शनकर्ता',
    'performance.needsAttention': 'ध्यान देने की जरूरत',
    'performance.subjects': 'विषय',
    'performance.assignments': 'असाइनमेंट',
    'performance.tests': 'परीक्षाएं',
    'performance.attendance': 'उपस्थिति',
    'performance.selectClass': 'कक्षा चुनें',
    'performance.selectSubject': 'विषय चुनें',
    'performance.selectTimeframe': 'समयसीमा चुनें',
    'performance.thisWeek': 'इस सप्ताह',
    'performance.thisMonth': 'इस महीने',
    'performance.thisQuarter': 'इस तिमाही',
    'performance.thisYear': 'इस वर्ष',
    'performance.generateReport': 'रिपोर्ट जेनरेट करें',
    'performance.exportData': 'डेटा निर्यात करें',
    'performance.insights': 'अंतर्दृष्टि',
    'performance.recommendations': 'सिफारिशें',

    // Doubt Solver
    'doubts.title': 'संदेह समाधान एआई',
    'doubts.subtitle': 'एआई-संचालित संदेह समाधान प्रणाली',
    'doubts.pendingDoubts': 'लंबित संदेह',
    'doubts.resolvedDoubts': 'हल किए गए संदेह',
    'doubts.aiSuggestions': 'एआई सुझाव',
    'doubts.studentName': 'छात्र का नाम',
    'doubts.subject': 'विषय',
    'doubts.question': 'प्रश्न',
    'doubts.submittedOn': 'पर जमा किया गया',
    'doubts.priority': 'प्राथमिकता',
    'doubts.status': 'स्थिति',
    'doubts.respond': 'जवाब दें',
    'doubts.markResolved': 'हल किया गया मार्क करें',
    'doubts.getAiHelp': 'एआई मदद लें',
    'doubts.priority.high': 'उच्च',
    'doubts.priority.medium': 'मध्यम',
    'doubts.priority.low': 'कम',
    'doubts.status.pending': 'लंबित',
    'doubts.status.inProgress': 'प्रगति में',
    'doubts.status.resolved': 'हल हो गया',

    // Student Dashboard
    'student.dashboard.title': 'छात्र डैशबोर्ड',
    'student.dashboard.welcome': 'वापस स्वागत है',
    'student.sidebar.dashboard': 'डैशबोर्ड',
    'student.sidebar.profile': 'प्रोफाइल',
    'student.sidebar.assignments': 'असाइनमेंट',
    'student.sidebar.progress': 'प्रगति',
    'student.sidebar.doubts': 'संदेह',
    'student.sidebar.schedule': 'शेड्यूल',
    'student.overview.pendingAssignments': 'लंबित असाइनमेंट',
    'student.overview.completedAssignments': 'पूर्ण असाइनमेंट',
    'student.overview.upcomingTests': 'आगामी परीक्षाएं',
    'student.overview.overallGrade': 'समग्र ग्रेड',
    'student.overview.recentActivities': 'हाल की गतिविधियां',
    'student.overview.quickActions': 'त्वरित कार्य',
    'student.overview.viewAssignments': 'असाइनमेंट देखें',
    'student.overview.askDoubt': 'संदेह पूछें',
    'student.overview.checkProgress': 'प्रगति जांचें',
    'student.overview.viewSchedule': 'शेड्यूल देखें',

    // Student Profile
    'student.profile.title': 'छात्र प्रोफाइल',
    'student.profile.personalInfo': 'व्यक्तिगत जानकारी',
    'student.profile.name': 'नाम',
    'student.profile.email': 'ईमेल',
    'student.profile.grade': 'कक्षा',
    'student.profile.school': 'स्कूल',
    'student.profile.rollNumber': 'रोल नंबर',
    'student.profile.parentInfo': 'अभिभावक की जानकारी',
    'student.profile.parentName': 'अभिभावक का नाम',
    'student.profile.parentPhone': 'अभिभावक का फोन',
    'student.profile.parentEmail': 'अभिभावक का ईमेल',
    'student.profile.address': 'पता',
    'student.profile.joinedDate': 'शामिल होने की तारीख',
    'student.profile.editProfile': 'प्रोफाइल संपादित करें',
    'student.profile.changePassword': 'पासवर्ड बदलें',

    // Assignments
    'assignments.title': 'असाइनमेंट',
    'assignments.pending': 'लंबित',
    'assignments.completed': 'पूर्ण',
    'assignments.overdue': 'समय सीमा समाप्त',
    'assignments.subject': 'विषय',
    'assignments.dueDate': 'अंतिम तिथि',
    'assignments.status': 'स्थिति',
    'assignments.marks': 'अंक',
    'assignments.submit': 'जमा करें',
    'assignments.view': 'देखें',
    'assignments.download': 'डाउनलोड',
    'assignments.feedback': 'फीडबैक',

    // Progress
    'progress.title': 'प्रगति ट्रैकिंग',
    'progress.academic': 'शैक्षणिक प्रगति',
    'progress.subjects': 'विषयवार प्रगति',
    'progress.overall': 'समग्र प्रदर्शन',
    'progress.monthly': 'मासिक प्रगति',
    'progress.weekly': 'साप्ताहिक प्रगति',
    'progress.attendance': 'उपस्थिति',
    'progress.grades': 'ग्रेड',
    'progress.improvement': 'सुधार के क्षेत्र',
    'progress.strengths': 'शक्तियां',
    'progress.weaknesses': 'काम करने के क्षेत्र',

    // Schedule
    'schedule.title': 'शेड्यूल',
    'schedule.today': 'आज',
    'schedule.week': 'इस सप्ताह',
    'schedule.month': 'इस महीने',
    'schedule.upcoming': 'आगामी',
    'schedule.class': 'कक्षा',
    'schedule.time': 'समय',
    'schedule.room': 'कमरा',
    'schedule.teacher': 'शिक्षक',
    'schedule.type': 'प्रकार',
    'schedule.lecture': 'व्याख्यान',
    'schedule.lab': 'लैब',
    'schedule.test': 'परीक्षा',
    'schedule.assignment': 'असाइनमेंट',

    // Test Analysis
    'testAnalysis.title': 'परीक्षा विश्लेषण',
    'testAnalysis.subtitle': 'एआई-संचालित परीक्षा विश्लेषण और अंतर्दृष्टि',
    'testAnalysis.uploadTest': 'परीक्षा पत्र अपलोड करें',
    'testAnalysis.analyzing': 'परीक्षा पत्रों का विश्लेषण हो रहा है...',
    'testAnalysis.results': 'विश्लेषण परिणाम',
    'testAnalysis.insights': 'मुख्य अंतर्दृष्टि',
    'testAnalysis.recommendations': 'सिफारिशें',
    'testAnalysis.questionAnalysis': 'प्रश्नवार विश्लेषण',
    'testAnalysis.studentPerformance': 'छात्र ���्रदर्शन',
    'testAnalysis.difficultyDistribution': 'कठिनाई वितरण',
    'testAnalysis.topicCoverage': 'विषय कवरेज',
    'testAnalysis.improvementAreas': 'सुधार के क्षेत्र',
    'testAnalysis.generateReport': 'रिपोर्ट जेनरेट करें',
  },
};